import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const productService = {};

// sản phẩm/ dịch vụ
productService.listItems = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort
) {
  return fetch({
    url: `${env.API_MSP}/items`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
      "filter[record_status]": "O",
    },
  });
};

// Detail sản phẩm/ dịch vụ
productService.detailItems = function (id) {
  return fetch({
    url: `${env.API_MSP}/items/${id}`,
    method: "get",
  });
};

// Create sản phẩm/ dịch vụ
productService.createItems = function (data) {
  return fetch({
    url: `${env.API_MSP}/items`,
    method: "post",
    data,
  });
};

// Create list sản phẩm/ dịch vụ
productService.createListItems = function (data) {
  return fetch({
    url: `${env.API_MSP}/items/record`,
    method: "post",
    data: {
      items: data,
    },
  });
};

// Edit sản phẩm/ dịch vụ
productService.editItems = function (data, id) {
  return fetch({
    url: `${env.API_MSP}/items/${id}`,
    method: "put",
    data,
  });
};

// Delete sản phẩm/ dịch vụ
productService.deleteItems = function (id) {
  return fetch({
    url: `${env.API_MSP}/items/${id}`,
    method: "delete",
  });
};

// listVats
productService.listVats = function () {
  return fetch({
    url: `${env.API_MSP}/vats?filter[record_status]=O`,
    method: "get",
    params: {
      page: -1,
      fields: "tsuat,ltsuat,id",
      sort: "tsuat",
    },
  });
};

// listVats
productService.listAllProduct = function ({ keyWord }) {
  return fetch({
    url: `${env.API_MSP}/items`,
    method: "get",
    params: {
      page: 1,
      sizePerPage: 20,
      fields: "code,id_vat,name,price,unit,id,vat_text",
      sort: "-id",
      "filter[record_status]": "O",
      keywords: keyWord,
    },
  });
};

export default productService;
